import {
  FetchImageCropsFilters,
  FetchImageCropsSort,
  FetchImageCropsLimit,
  FetchImageCropsGqlQuery,
  FetchImageCropsCacheKey
} from '../../imageCropsTypes';

import {
  INITIAL_IMAGE_CROPS_FILTERS,
  INITIAL_IMAGE_CROPS_LIMIT,
  INITIAL_IMAGE_CROPS_SORT
} from '../../imageCropsConstants';

import {
  useInfiniteIndexQuery,
  InfiniteIndexQueryBaseNodeType
} from '../../../common/reactQuery/hooks/useInfiniteIndexQuery';

interface ImageCropsOptions {
  cacheKey: FetchImageCropsCacheKey;
  query: FetchImageCropsGqlQuery;
  initialFilters?: FetchImageCropsFilters;
  initialSort?: FetchImageCropsSort;
  initialLimit?: FetchImageCropsLimit;
  options?: {
    cacheTime?: number;
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
}

const scope = 'imageCrops';

function useImageCrops<
  ImageCropItemType extends InfiniteIndexQueryBaseNodeType
>({
  cacheKey,
  query,
  initialFilters = INITIAL_IMAGE_CROPS_FILTERS,
  initialSort = INITIAL_IMAGE_CROPS_SORT,
  initialLimit = INITIAL_IMAGE_CROPS_LIMIT,
  options = {}
}: ImageCropsOptions) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isLoading,
    isFetchingNextPage,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    hasNextPage,
    updateItemCache,
    loadMoreItems,
    clearItemsFilters,
    filterItems,
    sortItems,
    limitItems
  } = useInfiniteIndexQuery<ImageCropItemType>({
    cacheKey,
    initialFilters,
    initialLimit,
    initialSort,
    options,
    query,
    scope
  });

  return {
    imageCropsData: data,
    imageCrops: items,
    imageCropsError: itemsError,
    imageCropsTotalCount: itemsTotalCount,
    imageCropsFetched: isFetched,
    imageCropsLoading: isLoading,
    imageCropsFetchingNextPage: isFetchingNextPage,
    imageCropsIsPlaceholderData: isPlaceholderData,
    imageCropsFilters: currentFilters,
    imageCropsSort: currentSort,
    imageCropsPage: currentPage,
    imageCropsLimit: currentLimit,
    hasNextImageCropsPage: hasNextPage,
    updateImageCropCache: updateItemCache,
    loadMoreImageCrops: loadMoreItems,
    filterImageCrops: filterItems,
    clearImageCropsFilters: clearItemsFilters,
    sortImageCrops: sortItems,
    limitImageCrops: limitItems
  };
}

export default useImageCrops;
